/* ==========================================================================
   OCTA — theme.js
   Vanilla JS, no framework/build step (matches the original mockup). Each
   init* function is scoped to the elements it needs so it's safe to call on
   every page even if that page doesn't have the markup.
   ========================================================================== */
(function () {
  'use strict';

  var routes = window.Shopify && window.theme && window.theme.routes ? window.theme.routes : {
    cart_add_url: '/cart/add',
    cart_change_url: '/cart/change',
    cart_url: '/cart'
  };

  /* ---------------- HEADER: filter + search dropdowns ---------------- */
  function initHeaderDropdowns() {
    document.querySelectorAll('.filter-wrap').forEach(function (wrap) {
      var toggle = wrap.querySelector('.icon-btn');
      var panel = wrap.querySelector('.filter-panel');
      if (!toggle || !panel) return;
      var backdrop = document.getElementById('filter-backdrop');

      function open() {
        document.querySelectorAll('.filter-panel.open').forEach(function (p) { p.classList.remove('open'); });
        panel.classList.add('open');
        toggle.classList.add('is-active');
        if (backdrop) backdrop.classList.add('open');
      }
      function close() {
        panel.classList.remove('open');
        toggle.classList.remove('is-active');
        if (backdrop) backdrop.classList.remove('open');
      }
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        panel.classList.contains('open') ? close() : open();
      });
      panel.addEventListener('click', function (e) { e.stopPropagation(); });
      var closeBtn = panel.querySelector('#filter-close, #cart-notification-close, #mobile-nav-close');
      if (closeBtn) closeBtn.addEventListener('click', close);
      var applyBtn = panel.querySelector('#apply-filters');
      if (applyBtn) applyBtn.addEventListener('click', close);
      if (backdrop) backdrop.addEventListener('click', close);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    });
  }

  /* ---------------- HERO CAROUSEL ---------------- */
  function initHeroCarousels() {
    document.querySelectorAll('.hero').forEach(function (hero) {
      var slides = hero.querySelectorAll('.hero-slide');
      var dots = hero.querySelectorAll('.hero-dot');
      var progress = hero.querySelector('.hero-progress');
      if (slides.length < 2) return;
      slides.forEach(function (s) { s.style.opacity = ''; s.style.visibility = ''; });
      var duration = parseInt(hero.dataset.duration, 10) || 5000;
      var current = 0;
      var autoTimer, progressTimer;

      function show(i) {
        slides.forEach(function (s) { s.classList.remove('active'); });
        dots.forEach(function (d) { d.classList.remove('active'); });
        slides[i].classList.add('active');
        if (dots[i]) dots[i].classList.add('active');
        current = i;
        restart();
      }
      function change(dir) { show((current + dir + slides.length) % slides.length); }
      function restart() {
        clearInterval(autoTimer); clearInterval(progressTimer);
        if (!progress) return;
        progress.style.width = '0%';
        var start = Date.now();
        progressTimer = setInterval(function () {
          var pct = Math.min(100, ((Date.now() - start) / duration) * 100);
          progress.style.width = pct + '%';
        }, 50);
        autoTimer = setTimeout(function () { change(1); }, duration);
      }
      var prev = hero.querySelector('.hero-nav.prev');
      var next = hero.querySelector('.hero-nav.next');
      if (prev) prev.addEventListener('click', function () { change(-1); });
      if (next) next.addEventListener('click', function () { change(1); });
      dots.forEach(function (dot, i) { dot.addEventListener('click', function () { show(i); }); });
      restart();
    });
  }


  /* ---------------- PRODUCT GALLERY ---------------- */
  function initGallery() {
    document.querySelectorAll('.gallery').forEach(function (gallery) {
      var mainImg = gallery.querySelector('.gallery-main img');
      var thumbs = gallery.querySelectorAll('.gallery-thumb');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var img = thumb.querySelector('img');
          if (!mainImg || !img) return;
          mainImg.src = img.dataset.fullSrc || img.src;
          mainImg.style.objectPosition = img.style.objectPosition || 'center center';
          thumbs.forEach(function (t) { t.classList.remove('active'); });
          thumb.classList.add('active');
        });
      });
    });
  }

  /* ---------------- VARIANT PICKER + QTY STEPPER + ADD TO CART ---------------- */
  function initProductForm() {
    var formEl = document.querySelector('[data-product-form]');
    if (!formEl) return;

    var variantsJson = document.getElementById('product-variants-json');
    var variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
    var variantIdInput = formEl.querySelector('[name="id"]');
    var priceEl = document.getElementById('product-price');
    var comparePriceEl = document.getElementById('product-price-old');
    var addBtn = formEl.querySelector('.btn-add-cart');
    var optionGroups = formEl.querySelectorAll('[data-option-index]');
    var b2bBlock = document.getElementById('b2b-tax-breakdown');
    var b2bNetoEl = document.getElementById('b2b-precio-neto');
    var b2bIvaEl = document.getElementById('b2b-precio-iva');
    var ivaRate = b2bBlock ? parseFloat(b2bBlock.dataset.ivaRate) : null;

    function money(cents) {
      return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function currentSelection() {
      var selected = [];
      optionGroups.forEach(function (group) {
        var active = group.querySelector('.pill.active');
        selected[parseInt(group.dataset.optionIndex, 10)] = active ? active.dataset.value : null;
      });
      return selected;
    }

    function findVariant(selection) {
  if (optionGroups.length === 0) {
    return variants[0];
  }
  return variants.find(function (v) {
    return v.options.every(function (opt, i) { return opt === selection[i]; });
  });
}

    function updateUI() {
      var selection = currentSelection();
      var variant = findVariant(selection);

      optionGroups.forEach(function (group) {
        var labelEl = document.getElementById('selected-' + group.dataset.optionIndex);
        var active = group.querySelector('.pill.active');
        if (labelEl && active) labelEl.textContent = active.dataset.value;
      });

      if (variant) {
        if (variantIdInput) variantIdInput.value = variant.id;
        if (priceEl) priceEl.textContent = money(variant.price);
        if (comparePriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceEl.textContent = money(variant.compare_at_price);
            comparePriceEl.hidden = false;
          } else {
            comparePriceEl.hidden = true;
          }
        }
        if (b2bBlock && b2bNetoEl && b2bIvaEl && ivaRate) {
  var precioNetoCents = variant.price / ivaRate;
  var precioIvaCents = variant.price - precioNetoCents;
  b2bNetoEl.textContent = money(precioNetoCents);
  b2bIvaEl.textContent = money(precioIvaCents);
}
        if (addBtn) {
  var isPreorder = variant.available && variant.inventory_management && variant.inventory_quantity <= 0;
  addBtn.disabled = !variant.available;
  addBtn.classList.toggle('btn-preorder', !!isPreorder);
  addBtn.textContent = isPreorder
    ? addBtn.dataset.labelPreorder
    : (variant.available ? addBtn.dataset.labelAvailable : addBtn.dataset.labelSoldOut);
}
      } else if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.dataset.labelUnavailable;
      }
    }

    optionGroups.forEach(function (group) {
      group.querySelectorAll('.pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('.pill').forEach(function (p) { p.classList.remove('active'); });
          pill.classList.add('active');
          updateUI();
        });
      });
    });
    updateUI();

    /* qty stepper */
    var qtyInput = formEl.querySelector('.qty-stepper input');
    formEl.querySelectorAll('.qty-stepper button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var delta = parseInt(btn.dataset.delta, 10);
        var value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
        qtyInput.value = value;
      });
    });

    /* ajax add to cart */
    formEl.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn && addBtn.disabled) return;
      var formData = new FormData(formEl);
      fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function (item) {
          if (item.status) { throw item; }
          showCartNotification(item);
          refreshCartCount();
        })
        .catch(function (err) {
          console.error('OCTA: add to cart failed', err);
        });
    });
  }

  /* ---------------- CART NOTIFICATION (mini cart) ---------------- */
  function showCartNotification(item) {
    var notif = document.getElementById('cart-notification');
    var body = document.getElementById('cart-notification-body');
    if (!notif || !body) return;
    body.innerHTML =
      '<div class="cart-notification-item">' +
        (item.image ? '<img src="' + item.image + '" alt="' + item.product_title + '">' : '') +
        '<div><h5>' + item.product_title + '</h5><span>' + item.variant_options.join(' · ') + '</span></div>' +
      '</div>';
    notif.classList.add('open');
    clearTimeout(notif._hideTimer);
    notif._hideTimer = setTimeout(function () { notif.classList.remove('open'); }, 6000);
  }

  function initCartNotificationClose() {
    var notif = document.getElementById('cart-notification');
    var closeBtn = document.getElementById('cart-notification-close');
    if (closeBtn && notif) closeBtn.addEventListener('click', function () { notif.classList.remove('open'); });
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var badge = document.getElementById('cart-count-badge');
        if (!badge) return;
        badge.textContent = cart.item_count;
        badge.hidden = cart.item_count === 0;
      });
  }

  /* ---------------- CART PAGE (ajax qty / remove) ---------------- */
  function initCartPage() {
    var cartItems = document.getElementById('cart-items');
    if (!cartItems) return;

    function money(cents) {
      return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function updateCartUI(cart) {
      document.getElementById('summary-subtotal').textContent = money(cart.total_price);
      document.getElementById('summary-total').textContent = money(cart.total_price);
      var countLabel = document.getElementById('cart-count-label');
      if (countLabel) {
        countLabel.textContent = cart.item_count === 0
          ? countLabel.dataset.emptyLabel
          : cart.item_count + (cart.item_count === 1 ? countLabel.dataset.singular : countLabel.dataset.plural);
      }
      cart.items.forEach(function (line, idx) {
        var row = cartItems.querySelector('[data-line="' + (idx + 1) + '"]');
        if (!row) return;
        row.querySelector('.qty-num').textContent = line.quantity;
        row.querySelector('.line-total').textContent = money(line.final_line_price);
      });
      var badge = document.getElementById('cart-count-badge');
      if (badge) { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; }
      if (cart.item_count === 0) { window.location.reload(); }
    }

    function changeLine(line, quantity) {
      fetch(routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(updateCartUI)
        .catch(function (err) { console.error('OCTA: cart update failed', err); });
    }

    cartItems.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;
      var row = btn.closest('.cart-item');
      var line = parseInt(row.dataset.line, 10);

      if (btn.classList.contains('cart-item-remove')) {
        changeLine(line, 0);
        row.remove();
      } else if (btn.dataset.delta) {
        var input = row.querySelector('.qty-num, input[name="quantity"]');
        var current = parseInt(row.querySelector('.qty-num').textContent, 10);
        var next = Math.max(1, current + parseInt(btn.dataset.delta, 10));
        changeLine(line, next);
      }
    });

    var promoForm = document.getElementById('promo-form');
    if (promoForm) {
      promoForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var code = promoForm.querySelector('input').value.trim();
        if (!code) return;
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart';
      });
    }
  }

  /* ---------------- CUSTOMER LOGIN: forgot-password toggle ---------------- */
  function initAuthRecoverToggle() {
    var showLink = document.getElementById('show-recover');
    var hideLink = document.getElementById('hide-recover');
    var loginPanel = document.getElementById('panel-login');
    var recoverPanel = document.getElementById('panel-recover');
    if (!showLink || !recoverPanel || !loginPanel) return;
    showLink.addEventListener('click', function (e) {
      e.preventDefault();
      loginPanel.classList.remove('active');
      recoverPanel.classList.add('active');
    });
    if (hideLink) {
      hideLink.addEventListener('click', function (e) {
        e.preventDefault();
        recoverPanel.classList.remove('active');
        loginPanel.classList.add('active');
      });
    }
  }

  /* ---------------- PRODUCT RECOMMENDATIONS (native) ---------------- */
  function initProductRecommendations() {
    document.querySelectorAll('[id^="related-products-"]').forEach(function (el) {
      var url = el.dataset.url;
      if (!url) return;
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('#' + el.id);
          if (content && content.innerHTML.trim() !== '') { el.innerHTML = content.innerHTML; }
        })
        .catch(function (err) { console.error('OCTA: recommendations failed', err); });
    });
  }

  /* ---------------- POLICY PAGE: TOC scroll highlight ---------------- */
  function initPolicyToc() {
    var sections = document.querySelectorAll('.policy-section');
    var tocLinks = document.querySelectorAll('.policy-toc a');
    if (!sections.length || !tocLinks.length) return;
    function highlight() {
      var current = sections[0].id;
      sections.forEach(function (s) {
        if (window.scrollY >= s.offsetTop - 140) current = s.id;
      });
      tocLinks.forEach(function (a) {
        a.classList.toggle('active', a.getAttribute('href') === '#' + current);
      });
    }
    document.addEventListener('scroll', highlight);
    highlight();
  }
  /* ---------------- SEARCH: clear input after landing on results page ---------------- */
  function initClearSearchInput() {
    if (window.location.pathname !== '/search') return;
    var searchInput = document.querySelector('input[name="q"]');
    if (searchInput) searchInput.value = '';
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeaderDropdowns();
    initHeroCarousels();
    initGallery();
    initProductForm();
    initProductRecommendations();
    initCartNotificationClose();
    initCartPage();
    initAuthRecoverToggle();
    initPolicyToc();
    initClearSearchInput();
  });
})();